import React, { useCallback, useEffect, useState } from 'react';
import { Segmented, Button, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { usePermissions } from '../contexts/PermissionContext';
import { getCasos, CasoMejoraCU2 } from '../api/mejoraCU2Api';
import CasosTable from '../components/MejoraCU2/CasosTable';
import CasoDetailModal from '../components/MejoraCU2/CasoDetailModal';
import GcPagina from '../components/Layout/GcPagina';
import { FctTarjeta } from '../fct/react';

const FILTROS = [
  { label: 'Abiertos', value: 'ABIERTOS' },
  { label: 'Nuevos', value: 'NUEVO' },
  { label: 'En análisis', value: 'EN_ANALISIS' },
  { label: 'Resueltos', value: 'RESUELTO' },
  { label: 'Cerrados', value: 'CERRADO' },
  { label: 'Todos', value: 'TODOS' },
];

const MejoraCU2Page: React.FC = () => {
  const { hasPermission } = usePermissions();
  const capacidades = {
    tratar: hasPermission('GCvsc.MejoraCU2.Tratar'),
    gestionar: hasPermission('GCvsc.MejoraCU2.Gestionar'),
  };
  const [casos, setCasos] = useState<CasoMejoraCU2[]>([]);
  const [loading, setLoading] = useState(false);
  const [filtro, setFiltro] = useState<string>('ABIERTOS');
  const [casoId, setCasoId] = useState<number | null>(null);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const estado = filtro === 'TODOS' || filtro === 'ABIERTOS' ? undefined : filtro;
      let data = await getCasos(estado);
      if (filtro === 'ABIERTOS') data = data.filter(c => c.estado !== 'CERRADO');
      setCasos(data);
    } catch {
      message.error('No se pudieron cargar los casos');
    } finally { setLoading(false); }
  }, [filtro]);

  useEffect(() => { cargar(); }, [cargar]);

  return (
    <GcPagina
      seccion="Mejora CU2"
      titulo="Mejora CU2"
      contexto="Casos GDO"
      densidad="compacta"
      acciones={<Button icon={<ReloadOutlined />} onClick={cargar} loading={loading}>Actualizar</Button>}
    >
      <FctTarjeta>
        <div className="fct-filtros" style={{ marginBottom: 16 }}>
          <Segmented options={FILTROS} value={filtro} onChange={(v) => setFiltro(v as string)} />
        </div>
        <CasosTable casos={casos} loading={loading} onRowClick={(c) => setCasoId(c.id)} />
      </FctTarjeta>
      <CasoDetailModal casoId={casoId} capacidades={capacidades} onClose={() => setCasoId(null)} onChanged={cargar} />
    </GcPagina>
  );
};

export default MejoraCU2Page;
